module.exports = __webpack_public_path__ + "static/media/Door1_Open.d94f0120.png";